import { getEventTarget } from '@src/utils/eventTarget';

const isEventNotInsideElement = (el, e, options = { bubble: false }) => {
  const target = getEventTarget(e);
  const pointInsideBody = (el.offsetLeft <= e.clientX && e.clientX <= el.offsetLeft + el.clientWidth)
    && (el.offsetTop <= e.clientY && e.clientY <= el.offsetTop + el.clientHeight);

  return options.bubble || (!el.contains(target) && el !== target && !pointInsideBody);
};

export default isEventNotInsideElement;
